export const MESSAGE_SOURCE = 'cms-bulk-publish'
export const BULK_PUBLISH_PARAM = 'bulkPublish'

export function postToParent(message) {
  if (window.parent === window) return

  window.parent.postMessage({ ...message, source: MESSAGE_SOURCE }, window.location.origin)
}

export function parseError(error) {
  const { response, message } = error || {}
  return String(response?.data?.message || response?.data?.error || message || 'Publish failed')
}
